import { render, staticRenderFns } from "./AddUpdateNews.vue?vue&type=template&id=fbcd731e&"
import script from "./AddUpdateNews.vue?vue&type=script&lang=js&"
export * from "./AddUpdateNews.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports